import moment from 'moment'

const displayHelpers = {
  methods: {
    dynamicFilter (val, format) {
      if (format === 'shDateTime') {
        return this.formatShDateTime(val)
      } else if (format === 'timeOnly') {
        return this.formatTimeOnly(val)
      } else if (format === 'min') {
        return this.formatMin(val)
      } else if (format === 'minAsHours') {
        return this.formatMinAsHours(val)
      } else if (format === '0-ano-bool') {
        if (val) {
          return 'ano'
        } else {
          return '0'
        }
      } else if (format === 'CZK') {
        return this.formatCurrency(val, 'CZK')
      }
      return val
    },
    formatTime (time) {
      return time ? moment(time).format('D.M.YYYY HH:mm') : ''
    },
    formatTimeAsDate (time) {
      return time ? moment(time).format('DD.MM.YY') : ''
    },
    formatTimeShort (time) {
      if (moment(time, 'HH:mm').isValid()) {
        return moment(time).format('HH:mm')
      } else {
        return ''
      }
    },
    formatTimeOnly (val) {
      return val ? moment(val).format('H:mm') : ''
    },
    formatDateOnly (val) {
      return val ? moment(val).format('D.M.YYYY') : ''
    },
    formatDateTime (val) {
      return val ? moment(val).format('D.M.YYYY HH:mm') : ''
    },
    formatShDatePastYears (val) {
      if (moment(val).startOf('year').isSame(moment().startOf('year'))) {
        return val ? moment(val).format('D.M.') : ''
      }
      return val ? moment(val).format('D.M.YY') : ''
    },
    formatShDateTimePastYears (val) {
      if (moment(val).startOf('year').isSame(moment().startOf('year'))) {
        return val ? moment(val).format('D.M. HH:mm') : ''
      }
      return val ? moment(val).format('D.M.YY HH:mm') : ''
    },
    formatShDateTime (val) {
      return val ? moment(val).format('D.M. HH:mm') : ''
    },
    formatMin (val) {
      return val + ' min'
    },
    formatMinAsHours (val) {
      // Receives val in minutes, formats as HH:mm
      return val ? moment.utc(val * 60 * 1000).format('H:mm') : ''
    },
    formatCurrency (val, currency) {
      return Intl.NumberFormat('cs-CZ', { style: 'currency', currency: currency }).format(val)
    }
  },
  filters: {
    timeOnly (val) {
      return val ? moment(val).format('H:mm') : ''
    },
    dateOnly (val) {
      // return displayHelpers.methods.formatDateOnly(val)
      return val ? moment(val).format('D.M.YYYY') : ''
    },
    dateTime (val) {
      // return displayHelpers.methods.formatDateTime(val)
      return val ? moment(val).format('D.M.YYYY HH:mm') : ''
    },
    shDate (val) {
      return val ? moment(val).format('D.M.') : ''
    },
    shDateTime (val) {
      // return displayHelpers.methods.formatShDateTime(val)
      return val ? moment(val).format('D.M. HH:mm') : ''
    },
    shDatePastYears (val) {
      return displayHelpers.methods.formatShDatePastYears(val)
    },
    shDateTimePastYears (val) {
      return displayHelpers.methods.formatShDateTimePastYears(val)
    },
    dateListDelimiters (val) {
      if (val) {
        if (moment(val).startOf('year').isSame(moment().startOf('year'))) {
          return moment(val).format('ddd, MMM D')
        } else {
          return moment(val).format('ddd, MMM D, YYYY')
        }
      }
      return ''
    },
    fromNow (time, noTimeMsg = 'anytime') {
      if (!time) {
        return noTimeMsg
      }
      if (moment) {
        let momentize = time
        if (typeof time === 'string') {
          momentize = moment(time)
        }
        return momentize.fromNow()
      }
      throw new Error('[display-helpers][fromNow] fromNow is not available due to missing dependency "moment"')
    },
    units (val, units) {
      return val ? val + ' ' + units : ''
    },
    formatNumber (val) {
      return (val || val === 0) ? Intl.NumberFormat('cs-CZ', { style: 'decimal' }).format(val) : ''
    },
    crop (val) {
      let chars = 40
      if (val) {
        let text = String(val)
        if (text.length < (chars + 5)) {
          return text
        }
        return text.substr(0, chars) + '...'
      }
      return ''
    }
  }
}

export default displayHelpers
